import { Component, Input, OnInit } from '@angular/core';
import { AccSimpleInputTextFormControlInterface } from '../acc-simple-input-text-form.component';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject, finalize, map, of, Subscription, switchMap, tap } from 'rxjs';
import { Helper } from 'src/app/accountancy/utilities/classes/helper.class';

@Component({
  selector: 'app-simple-form-auto-complete-input',
  templateUrl: './simple-form-auto-complete-input.component.html',
  styleUrls: ['./simple-form-auto-complete-input.component.scss']
})
export class SimpleFormAutoCompleteInputComponent implements OnInit {

  @Input({ required: true }) public parentFormGroup!: FormGroup;
  @Input({ required: true }) public controlInfo!: AccSimpleInputTextFormControlInterface;
  @Input({ required: true }) public controlId!: string | number;

  public readonly filteredSelectValues$ = new BehaviorSubject<{ key: string, value: any }[]>([])

  ngOnInit(): void {
    const onValueChangeSub: Subscription = (this.parentFormGroup.controls?.[this.controlInfo.name].valueChanges).pipe(
      finalize(() => onValueChangeSub.unsubscribe()),
      switchMap(query => {
        const selectOptions$ = this.controlInfo.selectOptions$;
        if (!selectOptions$) return of([]);
        return selectOptions$.pipe(
          map(options => options.filter(opt => Helper.string.trimLowerCase(opt.key).includes(Helper.string.trimLowerCase(query))))
        );
      }),
      tap(data => this.filteredSelectValues$.next(data))
    ).subscribe();
  }

}
